'use strict';

import angular = require('angular');
export default class ObjectDangerSubstancesComponent {
	public restrict: any;
	public template: any;
	public scope: any;
	public controller: any;
	public controllerAs: any;
	public bindToController: any;

  constructor() {
    this.restrict = 'A'
    this.template = require('./object.danger.substances.component.html');
    this.scope = {
      alarmObject: '=',
      isEditable: '='
    };
    this.controller = ObjectDangerSubstancesComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class ObjectDangerSubstancesComponentController {
	public alarmObject: any;

  constructor() {
  }

  /**
   * Add a new substance
   */
  addSubstance() {
    var data = {
      location: '',
      type: '',
      risk: '',
      un: '',
      riskClass: 'DANGER',
      actions: '',
        quantity: '',
        protection: ''
      };
    if (angular.isUndefined(this.alarmObject.risks.substances)) {
      this.alarmObject.risks.substances = [];
    }
    this.alarmObject.risks.substances.push(data);
  };

}
